// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","white":"#ffffff","background-grey":"#f6f6f6","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","container":"VMtdb4IEtcS1_ygsOwh1W","suggestionsContainer":"_2Lxz_qszML7KEzPY4s51Pu","suggestionsList":"_3mg19P21F-I6EQah71ST8K","autoCompleteItem":"_2jcMsEwxARu7-Zij-BfO97"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/common/AutoComplete/AutoComplete.css
// module id = 932
// module chunks = 0